import styled from '@emotion/styled'
import { CircleOutlined } from '@mui/icons-material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Link } from 'react-router-dom'
import { getPxAsRem } from 'shared/utils'

export interface TaskButtonProps {
    displayName: string
    href: string
    isComplete: boolean
}

const StyledLink = styled(Link, {
    shouldForwardProp: (propName) => propName !== 'isComplete',
})<{ isComplete: boolean }>`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;
    padding-top: 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.palette.greyscale.grey_100};
    cursor: pointer;
    color: ${({ theme }) => theme.palette.greyscale.black};
    text-decoration: none;

    &:last-of-type {
        border-bottom: none;
    }
`

const FlexRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPxAsRem(16)};
`

const Label = styled.p`
    font-weight: 400;
    margin: 0;
`

const TaskButton = ({ displayName, href, isComplete }: TaskButtonProps) => (
    <StyledLink to={href} isComplete={isComplete}>
        <FlexRow>
            <CircleOutlined color="info" fontSize="large" />
            <Label>{`Complete ${displayName} Questionnaire`}</Label>
        </FlexRow>
        <ArrowForwardIcon />
    </StyledLink>
)

export default TaskButton
